import { useSelector } from 'react-redux'
import { makeStyles } from '@mui/styles'
import {
  type Field,
  type NamedEntity,
  PermissionArea,
} from '@pbt/pbt-ui-components'

import PuiCheckboxList from '~/components/common/PuiCheckboxList'
import { BusinessTypeName } from '~/constants/businesses'
import { getCRUDByArea } from '~/store/reducers/auth'
import { getPracticeTypes } from '~/store/reducers/constants'

const useStyles = makeStyles(
  () => ({
    typeCheckboxList: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  }),
  { name: 'PracticeDetailsTypes' },
)

interface PracticeDetailsTypesProps {
  onChange: (value: string[]) => void
  practiceTypeIds: Field
}

export const PracticeDetailsTypes = ({
  onChange,
  practiceTypeIds,
}: PracticeDetailsTypesProps) => {
  const classes = useStyles()

  const PracticeTypes = useSelector(getPracticeTypes)
  const supportPermissions = useSelector(getCRUDByArea(PermissionArea.SUPPORT))

  const filterBusinessTypes = (type: NamedEntity) => {
    if (type.name === BusinessTypeName.OMNICHANNEL) {
      return supportPermissions.update
    }
    return true
  }

  const items = PracticeTypes.filter(filterBusinessTypes)

  return (
    <PuiCheckboxList
      hideAllButton
      className={classes.typeCheckboxList}
      disabled={!supportPermissions.update}
      initialState={practiceTypeIds.value}
      items={items}
      onChange={onChange}
    />
  )
}
